import ReactHtmlParser from 'react-html-parser';
import baseRequest  from '../baseRequest';
import AppConfig    from '../../app/config/AppConfig';
import AnalyticsManager from '../../app/analytics';
import * as Popups from '../../constants/popup-types';
import { UpsalePopupStatus } from '../../app/enums';
import { getUpsalePopupStatus, createAnalyticsItemsList, reactParserCommonOptions } from '../../app/functions';

/* actions */
import * as Actions from '../../redux/actions';
import { contentApi } from '../../redux/api/content.api';

class AcquirePaidCouponRequest extends baseRequest {

    constructor(onPurchaseResponse, onAnyResponse, benefit = null, translations = {}, onClose = null) {
        super();
        this.payload            = {};
        this.dispatch           = null;
        this.response           = null;
        this.name               = 'AcquirePaidCouponRequest';
        this.Config             = new AppConfig();
        this.onPurchaseResponse = onPurchaseResponse;
        this.onAnyResponse      = onAnyResponse;
        this.benefit            = benefit;
        this.translations       = translations;
        this.onClose            = onClose;
    }

    execute(dispatch, payload) {
        this.payload = payload;
        this.dispatch = dispatch;
        this.call(this.Config.api.requests.acquirePaidCoupon, payload);
    }

    onSuccess() {
        this.updateState();
    }

    updateState() {
        this.onPurchaseResponse(this.response.data);
        this.onAnyResponse();
        this.dispatch(Actions.setCouponPayResult(this.response.data));
        this.dispatch(Actions.getUserData(false));
        this.dispatch(contentApi.endpoints.getHotYoterStatePanel.initiate(undefined, {
            forceRefetch: true,
        }));
    }

    onFailure() {
        this.onAnyResponse();
        AnalyticsManager.logBenefitPaidCouponFailed(this.payload?.benefitId);
        
        if (this.onClose) {
            this.onClose();
        }
        
        const err = this.response.err;
        
        if (this.benefit?.is_subsidized) {
            const status = getUpsalePopupStatus(err.status);
            AnalyticsManager.logUpsalePopupPresented(status);
            const itemsList = createAnalyticsItemsList(this.benefit.relatedBenefits, {
                item_list_name: 'upsale_popup'
            });

            AnalyticsManager.logUpsalePopupViewedItemList(itemsList);

            this.dispatchSubsidyPopup(
                err.content, 
                status,
                this.benefit,
            );
        } else {
            if (this.benefit?.relatedBenefits) {
                this.dispatchSubsidyPopup(
                    err.content || this.translations['upsell_popup_purchase_error_title'],
                    UpsalePopupStatus.NO_INVENTORY,
                    this.benefit,
                );
            } else {
                this.dispatch(Actions.addPopup({
                    type: Popups.GENERAL_MESSAGE,
                    text: ReactHtmlParser(err.content, reactParserCommonOptions()),
                }));
            }
        }
    }

    dispatchSubsidyPopup(content, status, benefit) {
        const { relatedBenefits, main: { title, upsell_popup_footer_text } } = benefit;
        this.dispatch(Actions.addPopup({
            type: Popups.SUBSIDY_POPUP,
            content,
            header: title,
            benefits: relatedBenefits,
            status,
            footerText: upsell_popup_footer_text
        }));
    }
}

export default AcquirePaidCouponRequest;
